// Compteur de caractères Gmail et poids estimé d'une signature : affichés sur la fiche (aperçu) et
// dans l'éditeur. Le poids = HTML + images (content-length lu une fois par URL, en-tête HEAD).
import { estimateWeight, formatBytes, GMAIL_SIGNATURE_MAX_CHARS, signatureImageUrls, WEIGHT_WARN_BYTES } from '../../../supabase/functions/_shared/core/index.ts';
import { h } from '../dom.ts';

/** Poids des images, lu une fois par URL ; null = inconnu (CORS, erreur). Partagé entre les vues. */
const imageBytes: Record<string, number | null> = {};

export function signatureMeters(opts: { short?: () => boolean } = {}): { el: HTMLElement; count: HTMLElement; weight: HTMLElement; update: (html: string) => void } {
  const count = h('span', { class: 'meter-count', title: 'Compteur Gmail : au-delà de 10 000 caractères, Gmail refuse la signature' });
  const weight = h('span', { class: 'meter-weight', title: 'Poids estimé à chaque ouverture de mail : HTML + logo + bannière + icônes. Vert sous 500 Ko.' });
  const el = h('span', { class: 'meters' }, count, weight);
  let lastHtml = '';
  const drawWeight = () => {
    const w = estimateWeight(lastHtml, imageBytes);
    weight.textContent = `≈ ${w.unknown ? '≥ ' : ''}${formatBytes(w.bytes)}`;
    weight.title = w.unknown ? `${w.unknown} image(s) de poids inconnu (non comptées)` : weight.title;
    weight.className = `meter-weight ${w.bytes > WEIGHT_WARN_BYTES ? 'warn' : 'ok'}`;
  };
  const update = (html: string) => {
    lastHtml = html;
    const n = html.length.toLocaleString('fr-FR');
    const max = GMAIL_SIGNATURE_MAX_CHARS.toLocaleString('fr-FR');
    count.textContent = opts.short?.() ? `${n} / ${max}` : `${n} / ${max} caractères`;
    count.className = `meter-count${html.length > GMAIL_SIGNATURE_MAX_CHARS ? ' bad' : ''}`;
    drawWeight();
    for (const url of signatureImageUrls(html)) {
      if (url in imageBytes) continue;
      imageBytes[url] = null;
      fetch(url, { method: 'HEAD' })
        .then((res) => {
          const n = Number(res.headers.get('content-length'));
          if (res.ok && Number.isFinite(n) && n > 0) imageBytes[url] = n;
        })
        .catch(() => {})
        .finally(drawWeight);
    }
  };
  return { el, count, weight, update };
}
